var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('p',{staticClass:"scroll-box-title",domProps:{"innerHTML":_vm._s(_vm.sanitizedFieldTitle)}}),_c('div',{staticClass:"form-scroll-box",domProps:{"innerHTML":_vm._s(_vm.sanitizedHelpText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }